export const MOCK_RTE_CONTENT = `
<p></p>
<p>While this course is scheduled for June 2024 <a href="javascript:void(0)" data-linktype="course" data-code="109221266Y">Modern Art Globally Oriented I</a> (blok 1)</p>
<p></p>
<p><strong>College of Humanities </strong></p>
<p><strong>General </strong></p>
<p><em>Semester 1 </em></p>
<ul>
   <li>link <a href="javascript:void(0)" data-linktype="course" data-code="109221266Y">Modern Art Globally Oriented I</a> (blok 1)</li>
   <li><a href="javascript:void(0)" data-linktype="course" data-code="111221816Y">Social Justice in Context</a> (block 1)</li>
   <li><a href="javascript:void(0)" data-linktype="course" data-code="109221276Y">Modern Art Globally Oriented II</a> (blok 2)</li>
   <li><a href="javascript:void(0)" data-linktype="course" data-code="111221826Y">Crime, Justice and Conflict Otherwise</a> (block 2)</li>
   <li><a href="javascript:void(0)" data-linktype="course" data-code="111221856Y">Democracy, Populism and Resistance</a> (block 3)</li>
</ul>
<p>&nbsp;</p>
<p><em>Semester 2 </em></p>
<ul type="bullets">
   <li>Hoorcolleges (1x 2 uur per week)</li>
   <li>Werkgroepen (2x 2 uur per week)</li>
</ul>
<p>&nbsp;</p>
<table>
   <tbody>
      <tr>
         <td style="width: 204px;" width="204">
            <p>Cursusweek</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>Werkvorm</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>Uren per week</p>
         </td>
      </tr>
      <tr>
         <td style="width: 204px;" width="204">
            <p>1-5</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>Hoorcollege</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2</p>
         </td>
      </tr>
      <tr>
         <td style="width: 204px;" width="204">
            <p>7-13</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>Hoorcollege</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2</p>
         </td>
      </tr>
      <tr>
         <td style="width: 204px;" width="204">
            <p>1-5</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>Werkgroep</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4</p>
         </td>
      </tr>
      <tr>
         <td style="width: 204px;" width="204">
            <p>7-12</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>Werkgroep</p>
         </td>
         <td style="width: 204px;" width="204">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4</p>
         </td>
      </tr>
   </tbody>
</table>
<p>&nbsp;</p>
<p><strong>While this course is scheduled for June 2024 (semester 2, block 6), a separate edition will take place only for &lsquo;resit&rsquo; students in January 2024 (semester 1, block 3). For enrollment in the resit group, please contact the study advisor.</strong></p>
<p>This course gives students practical insights in and experience with a research process in one of the themes covered by the Practicing Research Skills tutorials. In groups, students formulate a research design consisting of a central research question, a relevant theoretical context, and appropriate research methods. Subsequently, relevant qualitative and/or quantitative data are collected, processed and the results are reported. Finally, students present their findings and write an invidiual reflection on the research process.&nbsp;</p>
<p>Central in this course is the critical application&nbsp;of methodological tools acquired in previous stages of the BA curriculum.&nbsp;For example, questions may rise on the impact of specific methods on research outcomes, the availability of certain types of data and the method selected, or the flaws in the use of a method of your choice. In addition, with its emphasis on group work, the course aims to enhance collaborative skills.</p>
<p>&nbsp;</p>
<p><strong>OVERVIEW - tutorial groups in 2024</strong></p>
<p>&nbsp;</p>
<p><strong>RESEARCH PROJECT II&nbsp;</strong></p>
<p>RESEARCH PROJECT II</p>
<p><strong>&nbsp;</strong></p>
<p><strong>Tutorial 01</strong></p>
<p><strong>Lecturer:</strong> Salama Konat&eacute;</p>
<p><strong>Topic: </strong>Policy framings of institutional racism and ways of combatting it <em>(English/studenten hebben de mogelijkheid om in het Nederlands te schrijven)</em></p>
<p><strong>Method: </strong>Qualitative Policy Analysis, including Discourse and Frame Analysis</p>
<p><strong>Description: </strong>Over the past decade we have seen a remarkable shift in understandings of racism and racial discrimination, which is now more often conceptualized as being &lsquo;systemic&rsquo; and/or &lsquo;institutional&rsquo;. This understanding moves away from racism being an ideology or system of thought that is intentionally produced and reproduced by &lsquo;racists&rsquo;, towards seeing racism in terms of processes of reproduction that are grounded relations of power and in routines, stereotypes, organizational and institutional norms, and pre- or subconscious processes that structurally disadvantage people of color. In what ways has this relatively new understanding become prominent in policy discourses, antiracist social movements and in research on racism? And does it result in different proposals and interventions to combat racism? Are there already experiences and insights in practices and policies that aim to reduce institutional racism, and what can be learned from them? In this research project, we will select some relevant cases of policy domains and/or institutions where racial discrimination and racism are deemed &lsquo;institutional&rsquo; or &lsquo;systemic&rsquo;. We will focus on cases in the EU, the Netherlands and possibly one additional national context. We use methods of qualitative policy analysis, such as discourse and frame analysis, to unravel the ways in policy discourses &lsquo;societal issues are translated into policy problems that can be acted upon&rsquo;. We also study the responses (policies and practices) that are being developed because they may help to address institutional racism. Students will draw on both textual analysis of existing documents (including media resources) and qualitative interviews.</p>
`;
